import { useQuery } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../api/v1";
import { PaginatedApiResponse } from "../../../../types/api-response";
import axios from "../../../../utils/axiosInceptor";
import { Note } from "./types";

type NotesParams = {
  moduleId: string;
  page?: number;
  perPage?: number;
  module?: string;
};

type UseGetNotesOptions = NotesParams & {
  isEnabled?: boolean;
};

const getNotes = async (params: NotesParams) => {
  const url = `${apiV1Endpoint}/notes`;
  const response = await axios.get<PaginatedApiResponse<Note[]>>(url, { params });
  return response.data.result;
};

export const useGetNotes = (options: UseGetNotesOptions) => {
  const { moduleId, page, perPage, module, isEnabled = true } = options;

  const { data, isLoading } = useQuery({
    queryKey: ["notes", moduleId, page],
    queryFn: () => getNotes({ moduleId, page, perPage, module }),
    enabled: Boolean(moduleId) && isEnabled,
    refetchOnWindowFocus: false,
  });

  return {
    notesData: data,
    isLoadingNotes: isLoading,
  };
};
